<template>
  <div class="resource-center-container">
    <document-nav
      :menuList="menuList"
      :searchVal="keyword"
      :activeId="curFirstLevel.id"
      @search="handleSearch"
      @handleClick="handleClickMenu"
    ></document-nav>
    <div class="resource-main">
      <div class="left-catelog">
        <div class="main-title font-bold">{{$t('document.documentDirectory')}}</div>
        <div class="catelog-main">
          <el-tree
            :empty-text="$t('document.nodata')"
            node-key="id"
            :current-node-key="currentNodeKey"
            :default-expanded-keys="defaultExpanded"
            :data="treeData"
            :props="defaultProps"
            highlight-current
            @node-click="handleNodeClick"
          />
        </div>
      </div>
      <div class="resource-content">
        <div class="main">
          <div v-if="currentdetail.title" class="document-content">
            <div class="breadcrumbs">
              <span
                class="crumbs-item crumbs-active des_one_row"
                @click="clickBreadcrumbs(1)"
              >
                {{ curFirstLevel.title }}
              </span>
              <template v-if="curSecondLevel.title">
                <img
                  src="@/assets/image/icon/next-blue.png"
                  alt=""
                  class="next-btn"
                />
                <span
                  class="crumbs-item crumbs-active des_one_row"
                  @click="clickBreadcrumbs(2)"
                >
                  {{ curSecondLevel.title }}
                </span>
              </template>
              <template v-if="currentdetail.title">
                <img
                  src="@/assets/image/icon/next-gray.png"
                  alt=""
                  class="next-btn"
                />
                <span class="crumbs-item last-crumb des_one_row">
                  {{ stripHtmlTags(currentdetail.title) }}
                </span>
              </template>
            </div>
            <div
              v-if="currentdetail.title"
              class="document-title font-bold"
              v-html="currentdetail.title"
            ></div>
            <div v-if="currentdetail.updateTime" class="create-time">
              <img src="@/assets/image/icon/time.png" alt="" />
              <span class="times"
                >{{$t('document.updateTime')}}：{{ currentdetail.updateTime }}</span
              >
            </div>
            <div
              id="documentContent"
              class="documnet-content language-"
              v-html="sanitizedHtml"
              @click="getImg"
            ></div>
          </div>

          <div v-if="loaded && !currentdetail.title" class="no-content">
            <img
              width="314"
              src="@/assets/image/empty@3x.png"
              class="load-more-icon"
              alt=""
            />
            <div class="txt">{{$t('document.noContent')}}</div>
          </div>

          <!-- 分页 -->
          <div class="pre-next-paging">
            <div class="pre-next-content">
              <div
                :class="['left', previousdetail?.title ? '' : 'no-next']"
                @click="toNextPage(previousdetail)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.4741 8.86203C9.39133 8.94791 9.27784 8.99742 9.15859 8.99967C9.03933 9.00192 8.92406 8.95673 8.8381 8.87403L6.1381 6.32403C6.09455 6.28205 6.05991 6.23172 6.03625 6.17605C6.01259 6.12039 6.00039 6.06052 6.00039 6.00003C6.00039 5.93954 6.01259 5.87967 6.03625 5.824C6.05991 5.76833 6.09455 5.71801 6.1381 5.67603L8.8381 3.12603C8.88022 3.08298 8.93055 3.04882 8.9861 3.02558C9.04166 3.00234 9.10132 2.99049 9.16155 2.99073C9.22177 2.99096 9.28133 3.00329 9.33671 3.02697C9.39208 3.05065 9.44214 3.0852 9.48391 3.12858C9.52568 3.17196 9.55833 3.22329 9.5799 3.27952C9.60147 3.33574 9.61154 3.39573 9.60951 3.45592C9.60748 3.51611 9.59338 3.57528 9.56806 3.62992C9.54274 3.68456 9.50671 3.73357 9.4621 3.77403L7.0993 6.00003L9.4621 8.22603C9.54798 8.3088 9.59749 8.42229 9.59974 8.54155C9.60199 8.6608 9.5568 8.77607 9.4741 8.86203ZM5.8741 8.86203C5.79133 8.94791 5.67784 8.99742 5.55859 8.99967C5.43933 9.00192 5.32406 8.95673 5.2381 8.87403L2.5381 6.32403C2.49455 6.28205 2.45991 6.23172 2.43625 6.17605C2.41259 6.12039 2.40039 6.06052 2.40039 6.00003C2.40039 5.93954 2.41259 5.87967 2.43625 5.824C2.45991 5.76833 2.49455 5.71801 2.5381 5.67603L5.2381 3.12603C5.28022 3.08298 5.33055 3.04882 5.38611 3.02558C5.44166 3.00234 5.50132 2.99049 5.56155 2.99073C5.62177 2.99096 5.68133 3.00329 5.73671 3.02697C5.79208 3.05065 5.84214 3.0852 5.88391 3.12858C5.92568 3.17196 5.95833 3.22329 5.9799 3.27952C6.00147 3.33574 6.01154 3.39573 6.00951 3.45592C6.00748 3.51611 5.99338 3.57528 5.96806 3.62992C5.94274 3.68456 5.90671 3.73357 5.8621 3.77403L3.4993 6.00003L5.8621 8.22603C5.94798 8.3088 5.99749 8.42229 5.99974 8.54155C6.00199 8.6608 5.9568 8.77607 5.8741 8.86203Z"
                    fill="#333333"
                  />
                </svg>
                <span>{{$t('download.previous')}}：{{ previousdetail?.title || $t('download.none') }}</span>
              </div>
              <div
                :class="['right', nextdetail?.title ? '' : 'no-next']"
                @click="toNextPage(nextdetail)"
              >
                <span>{{$t('download.next')}}：{{ nextdetail?.title || $t('download.none') }}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.4741 8.86203C9.39133 8.94791 9.27784 8.99742 9.15859 8.99967C9.03933 9.00192 8.92406 8.95673 8.8381 8.87403L6.1381 6.32403C6.09455 6.28205 6.05991 6.23172 6.03625 6.17605C6.01259 6.12039 6.00039 6.06052 6.00039 6.00003C6.00039 5.93954 6.01259 5.87967 6.03625 5.824C6.05991 5.76833 6.09455 5.71801 6.1381 5.67603L8.8381 3.12603C8.88022 3.08298 8.93055 3.04882 8.9861 3.02558C9.04166 3.00234 9.10132 2.99049 9.16155 2.99073C9.22177 2.99096 9.28133 3.00329 9.33671 3.02697C9.39208 3.05065 9.44214 3.0852 9.48391 3.12858C9.52568 3.17196 9.55833 3.22329 9.5799 3.27952C9.60147 3.33574 9.61154 3.39573 9.60951 3.45592C9.60748 3.51611 9.59338 3.57528 9.56806 3.62992C9.54274 3.68456 9.50671 3.73357 9.4621 3.77403L7.0993 6.00003L9.4621 8.22603C9.54798 8.3088 9.59749 8.42229 9.59974 8.54155C9.60199 8.6608 9.5568 8.77607 9.4741 8.86203ZM5.8741 8.86203C5.79133 8.94791 5.67784 8.99742 5.55859 8.99967C5.43933 9.00192 5.32406 8.95673 5.2381 8.87403L2.5381 6.32403C2.49455 6.28205 2.45991 6.23172 2.43625 6.17605C2.41259 6.12039 2.40039 6.06052 2.40039 6.00003C2.40039 5.93954 2.41259 5.87967 2.43625 5.824C2.45991 5.76833 2.49455 5.71801 2.5381 5.67603L5.2381 3.12603C5.28022 3.08298 5.33055 3.04882 5.38611 3.02558C5.44166 3.00234 5.50132 2.99049 5.56155 2.99073C5.62177 2.99096 5.68133 3.00329 5.73671 3.02697C5.79208 3.05065 5.84214 3.0852 5.88391 3.12858C5.92568 3.17196 5.95833 3.22329 5.9799 3.27952C6.00147 3.33574 6.01154 3.39573 6.00951 3.45592C6.00748 3.51611 5.99338 3.57528 5.96806 3.62992C5.94274 3.68456 5.90671 3.73357 5.8621 3.77403L3.4993 6.00003L5.8621 8.22603C5.94798 8.3088 5.99749 8.42229 5.99974 8.54155C6.00199 8.6608 5.9568 8.77607 5.8741 8.86203Z"
                    fill="#333333"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-navigation-wrap">
        <div v-if="contentNav.length > 0" class="right-navigation">
          <div class="main-title font-bold">{{$t('document.pageGuide')}}</div>
          <div class="navigation-wrap" id="docNav">
            <ul class="level1">
              <li
                :class="[
                  'nav-item',
                  'level1-item',
                  activeId === level1.id ? 'active-nav' : '',
                ]"
                v-for="(level1, index) in contentNav"
                :key="index"
              >
                <a
                  :class="[
                    'level1-title', 'des_four_row',
                    'font-bold',
                    browsePosition === level1.domId ? 'active-nav' : '',
                  ]"
                  @click="setScrollPosition($event, level1)"
                  v-html="level1.title"
                >
                </a>
                <ul
                  class="level2"
                  v-if="level1.children && level1.children.length > 0"
                >
                  <li
                    class="nav-item level2-item"
                    v-for="(level2, index) in level1.children"
                    :key="index"
                  >
                    <a
                      :class="[
                        'level2-title', 'des_four_row',
                        browsePosition === level2.domId ? 'active-nav' : '',
                      ]"
                      @click="setScrollPosition($event, level2)"
                      v-html="level2.title"
                    >
                    </a>
                    <ul
                      class="level3"
                      v-if="level2.children && level2.children.length > 0"
                    >
                      <li
                        class="nav-item level3-item"
                        v-for="(level3, index) in level2.children"
                        :key="index"
                      >
                        <a
                          :class="[
                            'level3-title',
                            browsePosition === level3.domId ? 'active-nav' : '',
                          ]"
                          @click="setScrollPosition($event, level3)"
                          v-html="level3.title"
                        >
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <preview-img ref="previewImgRef" />
  </div>
</template>

<script setup>
import previewImg from "@/components/previewImg";
import documentNav from "@/components/documentNav";
import {
  resourceCenter,
  resourceSubMenu,
  resourceDetail,
} from "@/api/developer";
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import prism from "prismjs";

// Add numbering to the Code blocks
import "prismjs/plugins/line-numbers/prism-line-numbers.js";
import "prismjs/plugins/line-numbers/prism-line-numbers.css";
import "prismjs/plugins/toolbar/prism-toolbar.js";
import "prismjs/plugins/toolbar/prism-toolbar.css";
import "prismjs/plugins/custom-class/prism-custom-class";
import "@/utils/prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard.js";
import "@/utils/prismjs/themes/custom.css";
import DOMPurify from "dompurify";
import { stripHtmlTags } from "@/utils";
import { setElementId } from "@/utils/document";
import { useI18n } from "vue-i18n";
const { locale, t } = useI18n();

const defaultProps = {
  children: "children",
  label: "title",
};
const router = useRouter();
const route = useRoute();
const previewImgRef = ref(null);
const curFirstLevel = ref({}); // 选中的一级菜单
const curSecondLevel = ref({}); // 选中的二级菜单
const menuList = ref([]);
const treeData = ref([]);
const defaultExpanded = ref([]);
const currentNodeKey = ref("");
const documentId = ref("");
const currentdetail = ref({});
const contentNav = ref([]);
const activeId = ref(0);
const hDomIdList = ref([]);
const nextdetail = ref({});
const previousdetail = ref({});
const keyword = ref(""); // 搜索关键词
const browsePosition = ref("heading_0"); // 浏览位置
const loaded = ref(false);
const scrollTimeout = ref(null)
const sanitizeConfig = {
  ADD_ATTR: ['target']
};
const sanitizedHtml = computed(() => {
  return DOMPurify.sanitize(currentdetail.value.contentDetail, sanitizeConfig);
});

// 监听滚动
const handleScroll = (e) => {
  if (!currentdetail.value.contentDetail) return;
  if (!contentNav.value.length) return;
  let activeHeadingId = null;
  hDomIdList.value.forEach((nav) => {
    const hel = document.getElementById(nav.domId);
    if (nav.domId === "heading_0" && hel.getBoundingClientRect().top > 0) {
      activeHeadingId = "heading_0";
    } else if (hel.getBoundingClientRect().top <= 10) {
      activeHeadingId = nav.domId;
    }
  });

  if (activeHeadingId) {
    browsePosition.value = activeHeadingId;
    const docNavBox = document.getElementById("docNav");
    const activeNav = docNavBox.getElementsByClassName("active-nav")[0];
    const navHeight = docNavBox.offsetHeight; // 导读总高度
    const activeTop = activeNav.offsetTop; // 选中栏距离顶部的距离
    if (activeTop - 20 > navHeight) {
      docNavBox.scrollTop = activeTop - 130;
    } else {
      docNavBox.scrollTop = 0;
    }
  }
};

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});

// 获取一级分类
const getcenterdata = async () => {
  await resourceCenter()
    .then((res) => {
      if (res.code === 200) {
        menuList.value = res.result;
        if (res.result.length > 0) {
          const params = route.query;
          const level1 = [...res.result].find(
            (item) => item.id === Number(params.menuId)
          );
          curFirstLevel.value = level1 || res.result[0];
          getSubMenuList();
        }
      }
    })
    .catch((err) => {
      console.log(err);
      loaded.value = true;
    });
};

getcenterdata();

// 点击一级菜单
const handleClickMenu = (data) => {
  if (data.id == route.query.menuId) return;
  loaded.value = false;
  router.replace({
    path: "/home/resourceCenter",
    query: {
      menuId: data.id,
    },
  });
  curFirstLevel.value = data;
  resetDocData();
  getSubMenuList();
};

// 获取二级菜单
const getSubMenuList = () => {
  treeData.value = [];
  resourceSubMenu({ parentId: curFirstLevel.value.id })
    .then((res) => {
      if (res.code === 200) {
        if (res.result.length > 0) {
          treeData.value = res.result;
          const params = route.query;
          const level2 = [...res.result].find(
            (item) => item.id === Number(params.submenuId)
          );
          curSecondLevel.value = level2 || res.result[0];
          getDefaultDoc();
        } else {
          loaded.value = true;
        }
      }
    })
    .catch(() => {
      loaded.value = true;
    });
};

// 获取二级菜单下的第一篇文档
const getDefaultDoc = () => {
  if (
    curSecondLevel.value.children &&
    curSecondLevel.value.children.length > 0
  ) {
    const params = route.query;
    const level3 = [...curSecondLevel.value.children].find(
      (item) => item.id === Number(params.docId)
    );
    documentId.value = level3?.id || curSecondLevel.value.children[0].id;
    defaultExpanded.value = [documentId.value];
    getdocumentDeatail();
  } else {
    loaded.value = true;
  }
};

// 点击左侧目录标题
const handleNodeClick = (data) => {
  if (!data.children && data.id && currentdetail.value.id !== data.id) {
    documentId.value = data.id;
    getdocumentDeatail();
    treeData.value.forEach((item) => {
      if (item.children && item.children.length > 0) {
        item.children.forEach((item2) => {
          if (item2.id === data.id) {
            curSecondLevel.value = item;
          }
        });
      }
    });
    router.replace({
      path: "/home/resourceCenter",
      query: {
        menuId: curFirstLevel.value.id,
        submenuId: curSecondLevel.value.id,
        docId: documentId.value,
      },
    });
  }

  if (data.children) {
    if (!data.children.length) {
      resetDocData();
      curSecondLevel.value = data;
    }
  }
};

// 重置文档内容
const resetDocData = () => {
  currentdetail.value = {};
  curSecondLevel.value = {};
  contentNav.value = [];
  nextdetail.value = {};
  previousdetail.value = {};
};

//根据id获取文章
const getdocumentDeatail = async () => {
  loaded.value = false;
  const params = route.query;
  keyword.value = params.key || "";
  currentNodeKey.value = documentId.value;
  await resourceDetail({
    documentDetailId: documentId.value,
    keyword: keyword.value,
  })
    .then((res) => {
      if (res.code === 200) {
        let {
          currentDocumentDetail,
          previousDocumentDetail,
          nextDocumentDetail,
        } = res.result;
        const newHdomList = setElementId(currentDocumentDetail.contentDetail);
        currentDocumentDetail.contentDetail = newHdomList;
        currentdetail.value = currentDocumentDetail;
        contentNav.value = getContentDirTree(newHdomList);
        nextdetail.value = nextDocumentDetail;
        previousdetail.value = previousDocumentDetail;
      }

      // 设置代码块高亮
      setTimeout(() => {
        prism.highlightAll();
      }, 0);
      loaded.value = true;
    })
    .catch((err) => {
      console.log(err);
      loaded.value = true;
    });
};

// 搜索
const handleSearch = (data) => {
  if (!data) return;
  router.push(
    `/home/searchResult?keyword=${data}&menuId=${curFirstLevel.value.id}`
  );
};

// 根据文章生成文档导读
const getContentDirTree = (htmlData) => {
  if (!htmlData) {
    return [];
  }
  let hDomList = htmlData.match(/<h[1-3]{1}[^>]*>([\s\S]*?)<\/h[1-3]{1}>/g);
  if (!Array.isArray(hDomList)) {
    return [];
  }
  const dirTree = [];
  let preDir;
  hDomList.forEach((hDom, index) => {
    const startIndex = hDom.indexOf('id="');
    const endIndex = hDom.indexOf('">');
    if (startIndex != -1 && endIndex != -1) {
      const domId = hDom.slice(startIndex + 4, endIndex);
      const re = /<h([1-3]{1})[^>]*>([\s\S]*?)<\/h[1-3]{1}>/;
      let hLevel = Number(hDom.replace(re, "$1"));
      let titleContent = hDom.replace(re, "$2");
      // 去掉h标签内的标签
      let title = titleContent.replaceAll(/<([\s\S]*?)>|<\/([\s\S]*?)>/g, "");
      if(route.query.key) {
        title = title.replaceAll(route.query.key, `<span style="color: #F43F31;">${route.query.key}</span>`)
      }
      const currentDir = {
        id: index + 1, //用于点击的时候选中态
        title,
        domId,
        hLevel,
      };
      if (preDir) {
        if (currentDir.hLevel === 1) {
          currentDir.pid = 0;
        } else if (currentDir.hLevel > preDir.hLevel) {
          currentDir.pid = preDir.id;
        } else if (currentDir.hLevel < preDir.hLevel) {
          const pLevel = currentDir.hLevel === 1 ? 1 : currentDir.hLevel - 1;
          const pDir = dirTree.filter((item) => item.hLevel === pLevel);
          currentDir.pid = pDir[pDir.length - 1].id;
        } else {
          currentDir.pid = preDir.pid;
        }
      } else {
        currentDir.pid = 0;
      }
      preDir = currentDir;
      dirTree.push(currentDir);
    }
  });
  hDomIdList.value = dirTree;

  dirTree.forEach((item) => {
    if (item.pid !== 0) {
      const findParent = dirTree.find((i) => i.id === item.pid);
      if (findParent) {
        if (!Array.isArray(findParent.children)) {
          findParent.children = [];
        }
        findParent.children.push(item);
      }
    }
  });
  return dirTree.filter((i) => i.pid === 0);
};

const setScrollPosition = (e, data) => {
  e.preventDefault();
  clearTimeout(scrollTimeout.value)
  scrollTimeout.value = null
  window.removeEventListener("scroll", handleScroll);
  browsePosition.value = data.domId;
  const hashEl = document.getElementById(data.domId);
  if (hashEl) {
    hashEl.scrollIntoView({ behavior: "smooth" });
  }
  scrollTimeout.value = setTimeout(() => {
    window.addEventListener("scroll", handleScroll);
  }, 1200);
};

// 获取图片
const getImg = (e) => {
  if (
    e.target.localName === "img" &&
    e.target.currentSrc &&
    e.target.currentSrc !== ""
  ) {
    previewImgRef.value.openPreview(e.target.currentSrc);
  }
};

// 上一篇/下一篇
const toNextPage = (data) => {
  if (!data.id) return;
  documentId.value = data.id;
  // 提前赋值,避免滚动条闪烁
  currentdetail.value = data;
  router.replace({
    path: "/home/resourceCenter",
    query: {
      menuId: curFirstLevel.value.id,
      submenuId: curSecondLevel.value.id,
      docId: documentId.value,
    },
  });
  setTimeout(() => {
    getdocumentDeatail();
  });
};

// 点击面包屑
const clickBreadcrumbs = (type) => {
  if (type == 1) {
    curSecondLevel.value = treeData.value[0];
    documentId.value = treeData.value[0].children[0].id || "";
  }
  if (type === 2) {
    if (curSecondLevel.value.children) {
      documentId.value = curSecondLevel.value.children[0].id || "";
    }
  }
  router.replace({
    path: "/home/resourceCenter",
    query: {
      menuId: curFirstLevel.value.id,
      submenuId: curSecondLevel.value.id,
      docId: documentId.value,
    },
  });
  setTimeout(() => {
    getdocumentDeatail();
  });
};
</script>

<style lang="scss" scoped>
.resource-center-container {
  width: 100%;
  height: 100%;
  padding-bottom: 40px;
  background-color: #f8f8f8;
  ul,
  li {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .resource-main {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    min-height: 800px;
    .left-catelog {
      width: 208px;
      min-height: 100%;
      margin-right: 16px;
      border-radius: 4px;
      background: #ffffff;
      padding-bottom: 40px;

      .main-title {
        font-size: 20px;
        line-height: 28px;
        text-align: left;
        margin: 16px;
        word-wrap: break-word;
        word-break: normal;
      }
    }
    .resource-content {
      width: 64.5%;
      padding-bottom: 88px;
      background: #ffffff;
      position: relative;
      .main {
        padding: 16px 24px 36px;
        .no-content {
          text-align: center;
          // margin-top: 167px;
          margin-top: 227px;
          .txt {
            color: #333;
            font-size: 14px;
            line-height: 28px;
            opacity: 0.4;
          }
        }
      }
      .breadcrumbs {
        display: flex;
        align-items: center;
        .crumbs-item {
          max-width: 200px;
          font-size: 12px;
          line-height: 17px;
          color: #666666;

          &.last-crumb {
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .crumbs-active {
          color: #386aea;
          cursor: pointer;
        }
        .next-btn {
          margin: 0 4px;
          width: 4px;
          height: auto;
          background: #ffffff;
        }
      }

      .document-title {
        font-size: 24px;
        line-height: 34px;
        color: #333333;
        margin-top: 24px;
      }
      .create-time {
        margin-top: 16px;
        display: flex;
        align-items: center;
        img {
          width: 14px;
          height: auto;
        }
        .times {
          margin-left: 4px;
          font-size: 12px;
          line-height: 17px;
          color: #666666;
        }
      }
      .documnet-content {
        margin-top: 32px;
        font-size: 14px;
        overflow: hidden;

        ::v-deep {
          h1 {
            font-size: 20px;
            line-height: 40px;
            color: #333333;
            margin-bottom: 16px;
            word-break: break-word;
          }
          h2 {
            font-size: 18px;
            line-height: 36px;
            color: #333333;
            margin-bottom: 16px;
            word-break: break-word;
          }
          h3 {
            font-size: 16px;
            line-height: 32px;
            color: #333333;
            margin-bottom: 16px;
            word-break: break-word;
          }
          h4,
          h5,
          h6 {
            font-size: 14px;
            line-height: 32px;
            color: #333333;
            margin-bottom: 24px;
            word-break: break-word;
          }
          p {
            line-height: 28px;
            color: #333333;
            padding: 0;
            margin: 0;
            // margin-bottom: 24px;
            margin-bottom: 16px;
          }

          // 配置说明文字
          .code-toolbar + p {
            /* 添加样式，例如修改颜色或边框 */
            margin-top: -10px;
          }

          div[data-w-e-type="video"] + p {
          }

          table + p {
            margin-top: 4px;
          }

          :is(p):has(> img) + p {
            margin-top: -20px;
          }

          span {
            display: inline-block;
            line-height: inherit;
            word-break: break-word!important;
          }

          p[style*="text-indent"] > span {
            padding-right: 24px;
          }

          p[style*="text-indent"] span span {
            text-indent: 0;
          }

          p:has(a) span {
            display: inline;
            padding: 0!important;
          }

          table,
          tr,
          td,
          th {
            caret-color: transparent !important;
          }
          th {
            text-align: center;
            font-weight: bold;
            padding: 12px 0 11px;
          }
          th,
          tr,
          td {
            color: #333333;
            border: 1px solid #e9e9e9;
            line-height: 28px;
          }
          td {
            padding: 12px;
            width: transparent !important;
            &:first-child {
              padding-left: 16px;
            }
          }

          td:not([style*="width: auto"]) {
            /* 添加你想要的样式 */
            width: calc(100% + 24px);
          }

          tr:nth-child(2n + 1) {
            background: #f8f8f8;
          }
          img {
            max-width: 100% !important;
            height: auto !important;
            cursor: pointer;
          }
          li span {
            display: inline;
          }
          blockquote {
            background: rgba(56, 106, 234, 0.08);
            padding: 12px 16px 16px 24px;
            position: relative;
            color: #333333;
            line-height: 28px;
            margin-bottom: 36px;
            border-radius: 4px;
            &::before {
              content: "";
              width: 8px;
              height: 100%;
              position: absolute;
              left: 0;
              top: 0;
              border-radius: 4px 0 0 4px;
              background: rgba(56, 106, 234, 0.8);
            }
          }
          .code-toolbar {
            padding-top: 26px;
            margin: 0.5em 0 1em;
            border-radius: 4px;
            overflow: hidden;
            background-color: #f8f8f8;
            &::before {
              content: "";
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 26px;
              background: #e9e9e9;
              border-radius: 4px 4px 0 0;
            }
            &::after {
              content: "";
              position: absolute;
              left: 0;
              top: 26px;
              width: 100%;
              height: 0.5em;
              background: #f8f8f8;
            }
            & > .toolbar {
              opacity: 1;
              top: 0.2em;
            }
            .copy-to-clipboard-button {
              box-shadow: none;
              color: #666666;
              font-size: 12px;
              padding-right: 26px;
              position: relative;
              &:hover {
                color: #666666;
              }
              &::after {
                content: "";
                width: 18px;
                height: 18px;
                position: absolute;
                top: 0px;
                right: 6px;
                background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHxSURBVHgB7ZnPbcIwFMZfogDiwgRlAgZAdIEu0KZnqvDvwKGwQDsDB/4UiROH0k7QBWgHYAJYACQEHIB+bkPL0YlfUCK938UOim2++NmWv0ckCIIgCIJwKSxipF6vu4fDoUSM2La9tCxr1u1234K0YxPWaDTy+/3+k6JjMhgMHnVftokJx3GWKFYUHS4i4kb3ZdZQLJfL+UwmwxqKfmi7/uMrZq2l084hRkaj0RzFnBjBLClxbtB2oYV5nndFjGSz2VWn02EL5cDCqtVqG7uUdzwec8TIbrejWq02S6fTDxC4IEMCbR4Y+BlFi1vUCfRbgMCvSqVSIEO0Z8zfzr2zn1aYuSUxAVH5Ux39qg94SwZoC8MCvjt7DHSm6KB21FQq9YGqioZSs9nMmay5UOcYvijrzqdQOyr6/ROy2WyMwp3tgI4bIixpiLCkIcKShghLGiIsaYiwpBF7Ybh4Tunf/Zrqtou9MHWdWa/XRdwHi7gDapumrC5VVIzHYzVjgS6dssaSRlhrICqXiq1f7TWmMh4Y+KeOhXwPK47Vp0ff1/Rr5Cjmw+HQyFvUFgYHabrdbhcQqBzgHP5ImyICY0zIkEBJCWWRIavy7ouLBOTDXnq93hMZEirbotI5yrUlRtCfMmBn/X5f+xAWBEEQBEGIB9880aVZYAsH0AAAAABJRU5ErkJggg==);
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
              }
            }
          }
        }
      }
    }
    .right-navigation-wrap {
      position: relative;
      width: 254px;
    }
    .right-navigation {
      margin-left: 16px;
      position: sticky;
      top: 80px;

      .main-title {
        font-size: 16px;
        line-height: 22px;
        margin: 80px 0 16px;
      }
      /* 四行溢出显示省略号*/
      .des_four_row {
          display: -webkit-box !important;
          -webkit-box-orient: vertical !important;
          -webkit-line-clamp: 4 !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
          word-break: break-word;
          // text-align: justify;

      }
      .navigation-wrap {
        height: 336px;
        overflow-x: hidden;
        overflow-y: auto;
        direction: rtl;
        padding-left: 16px;
        .level1 {
          direction: ltr;
          .nav-item {
            a {
              cursor: pointer;
              font-size: 14px;
              line-height: 28px;
              color: #666666;
              text-decoration: none;
              transition: all 0.3s;
            }
          }
          .level1-item {
            .level1-title {
              display: block;
              font-size: 16px;
              line-height: 32px;
              color: #333333;
              padding: 0 0 8px 0;
            }
          }
          .level2-item {
            .level2-title {
              display: block;
              margin: 0 0 4px 16px;
            }
          }
          .level3-item {
            .level3-title {
              display: block;
              margin: 0 0 4px 32px;
            }
          }
          .nav-item .active-nav {
            text-decoration: underline;
            color: #386aea;
          }
        }
      }
      ::v-deep {
        /* 滚动条轨道样式 */
        ::-webkit-scrollbar {
          width: 6px; /* 设置滚动条宽度 */
        }

        /* 滚动条滑块样式 */
        ::-webkit-scrollbar-thumb {
          background-color: #386aea; /* 设置滑块背景颜色 */
          border-radius: 5px; /* 设置滑块圆角 */
        }

        ::-webkit-scrollbar-track {
          background: #e9e9e9;
          border-radius: 5px;
        }
      }
    }
  }
  .pre-next-paging {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 88px;

    .pre-next-content {
      width: calc(100% - 48px);
      height: 88px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      line-height: 24px;
      color: #333333;
      border-top: 0.5px solid #e9e9e9;
      cursor: pointer;
      .left {
        text-align: left;
        span {
          margin-left: 4px;
        }
      }
      .right {
        text-align: right;
        span {
          margin-right: 4px;
        }
        svg {
          transform: rotate(180deg);
        }
      }
      .no-next {
        cursor: default;
        color: #999999;
        svg {
          path {
            fill: #999999;
          }
        }
      }
    }
  }

  ::v-deep {
    .el-tree-node__content > .el-tree-node__expand-icon {
      margin-left: 6px;
    }
    .el-tree-node__expand-icon:not(.is-leaf) {
      color: #333333;
    }
    .el-tree-node__label {
      color: #333333;
      white-space: normal;
      word-break: break-word;
      font-weight: bold;
      font-size: 12px;
      padding-right: 16px;
    }
    .el-tree-node__children .el-tree-node__label {
      font-weight: normal;
    }
    .el-tree-node__children {
      .el-tree-node__content {
        padding-left: 0 !important;
      }
    }
    .el-tree-node__content {
      padding: 12px 0;
      height: auto;
    }

    .el-tree-node__children {
      .el-tree-node__content {
        padding: 8px 0;
        height: auto;
      }
    }

    .el-tree--highlight-current
      .el-tree-node.is-current
      > .el-tree-node__content {
      background: #ffffff;
    }

    .el-tree--highlight-current
      .el-tree-node.is-current
      > .el-tree-node__content
      .el-tree-node__label {
      color: #386aea;
      white-space: normal;
    }
  }

}
</style>
